/**
 * Ödül Öneri e-posta alıcı çözümleyici (passthrough — gerçek alıcı).
 * @param {string} originalTo
 * @param {string} [htmlMessage]
 * @returns {{ to: string, message: string, originalTo: string }}
 */
export const resolveOdulOneriMailTarget = (originalTo, htmlMessage = '') => ({
  to: originalTo,
  message: htmlMessage,
  originalTo,
})
